type LocalTimeParts = {
    hour: number;
    minute: number;
};

const PRODUCT_REFRESH_DISPLAY_TIME: LocalTimeParts = { hour: 8, minute: 0 };

const isChineseLocale = (locale: string) => locale.toLowerCase().startsWith('zh');

const padMinute = (minute: number) => String(minute).padStart(2, '0');

const parseLocalTime = (localTime?: string | null): LocalTimeParts | null => {
    const match = String(localTime || '').trim().match(/^([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/u);
    if (!match) return null;

    return {
        hour: Number(match[1]),
        minute: Number(match[2]),
    };
};

const productDisplayTime = (time: LocalTimeParts): LocalTimeParts => (
    time.hour === 7 && time.minute === 50 ? PRODUCT_REFRESH_DISPLAY_TIME : time
);

const formatChineseTime = ({ hour, minute }: LocalTimeParts) => {
    const period = hour < 12 ? '上午' : '下午';
    const displayHour = hour % 12 || 12;
    return minute === 0
        ? `${period} ${displayHour} 点`
        : `${period} ${displayHour}:${padMinute(minute)}`;
};

const formatEnglishTime = ({ hour, minute }: LocalTimeParts) => {
    const period = hour < 12 ? 'AM' : 'PM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${padMinute(minute)} ${period}`;
};

export const formatOutcomeSummaryRefreshDisplayTime = (
    localTime: string | null | undefined,
    locale: string,
) => {
    const displayTime = productDisplayTime(parseLocalTime(localTime) ?? PRODUCT_REFRESH_DISPLAY_TIME);
    return isChineseLocale(locale) ? formatChineseTime(displayTime) : formatEnglishTime(displayTime);
};
